<template>
  <div>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
    <div class="hidden" id="prefetch-element"></div>
  </div>
</template>

<script lang="ts" setup>
  import { useAppStateStore } from '~/store/appState'

  const  $router = useRouter()
  const  $route = useRoute()
  let appStateStore = useAppStateStore()

  onBeforeMount(async () => {
    const eventIdParam = $route.params.eventId
    const eventIdQuery = $route.query.q ||  $route.query.eventId 
    const eventIdLocalStorage = window.localStorage.getItem('eventId')

    getQueryBackgroundColor()

    if(eventIdParam) {
      console.log('param --->', eventIdParam)
      window.localStorage.setItem('eventId', eventIdParam)
      return await appStateStore.init(eventIdParam)
    }

    if(eventIdQuery) {
      console.log('query --->', eventIdQuery)
      window.localStorage.setItem('eventId', eventIdQuery)
      return await appStateStore.init(eventIdQuery)
    }

    if(eventIdLocalStorage) {
      console.log('localstorage --->', eventIdLocalStorage)
      return await appStateStore.init(eventIdLocalStorage)
    }


    return $router.push('/')
  })

  const getQueryBackgroundColor = () => {
    const backgroundColor =  $route.query.background
    const backgroundColorLocalStorage = window.localStorage.getItem('backgroundColor')
    const isClearBackground =  $route.query.clear

    if(isClearBackground) {
      window.localStorage.removeItem('backgroundColor')
      return appStateStore.setBackgroundColor('000000')
    }

    if(backgroundColor) {
      window.localStorage.setItem('backgroundColor', backgroundColor)
      return appStateStore.setBackgroundColor(backgroundColor)
    }

    if(backgroundColorLocalStorage) {
      window.localStorage.setItem('backgroundColor', backgroundColorLocalStorage)
      return appStateStore.setBackgroundColor(backgroundColorLocalStorage)
    }

    appStateStore.setBackgroundColor('000000')
  }
</script>

<style>
</style>
